import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  tone = 'dark'
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  const isLight = tone === 'light';
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6,
    ease: [0.23, 1, 0.32, 1]
  }} className={`max-w-2xl ${isCenter ? 'mx-auto text-center' : ''}`} data-id="element-157" data-mp="bjtze1w16y4r">
      {eyebrow && <span className="text-xs font-semibold tracking-[0.2em] uppercase text-gold-dark" data-id="element-158" data-mp="6svd8lod35tl">
          {eyebrow}
        </span>}
      <h2 className={`mt-3 font-serif text-3xl md:text-4xl font-semibold tracking-tight ${isLight ? 'text-white' : 'text-navy'}`} data-id="element-159" data-mp="uhwqqnc1x75q">
        {title}
      </h2>
      <div className={`mt-5 h-[3px] w-16 bg-gold ${isCenter ? 'mx-auto' : ''}`} data-id="element-160" data-mp="1tah116mozkyu" />
      {description && <p className={`mt-5 text-base leading-relaxed ${isLight ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-161" data-mp="1ocpaoh1p46wr">
          {description}
        </p>}
    </motion.div>;
}